import { ethers } from "ethers";
import WalletConnectProvider from "@walletconnect/web3-provider";

//  Create WalletConnect Provider

export const GetAccount = async () => {
    const provider = new WalletConnectProvider({
        rpc: {
          56: "https://bsc-dataseed1.binance.org",
          // ...
        },
      });
      
      //  Enable session (triggers QR Code modal)
     // await provider.enable();
      const web3Provider = new ethers.providers.Web3Provider(provider);
      const acct = ( await web3Provider.getSigner().getAddress());
      return acct;
}
